webpackJsonp([72572670756384],{

/***/ 181:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'Padded ' + (props.className || '') },
	    props.children
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _row = __webpack_require__(43);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(37);
	
	var _col2 = _interopRequireDefault(_col);
	
	__webpack_require__(44);
	
	__webpack_require__(38);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Page = __webpack_require__(151);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Padded = __webpack_require__(150);
	
	var _Padded2 = _interopRequireDefault(_Padded);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(350);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var pathContext = _ref.pathContext;
	
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      className: 'doc-block no-playground',
	      shouldShowFooter: true,
	      title: pathContext.frontmatter.title },
	    _react2.default.createElement(
	      _Padded2.default,
	      null,
	      _react2.default.createElement(
	        _row2.default,
	        null,
	        _react2.default.createElement(
	          _col2.default,
	          { xl: 16, lg: 16, md: 24, sm: 24, xs: 24 },
	          _react2.default.createElement('div', {
	            className: 'markdown',
	            dangerouslySetInnerHTML: { __html: pathContext.html }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/docs', className: 'overview' },
	        'BACK TO OVERVIEW'
	      )
	    )
	  );
	}; /**
	    * Copyright (c) Meta Platforms, Inc. and affiliates.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    * @format
	    */

	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-without-playground-js-8841a2159d7471f3af5a.js